import React, { useEffect, useState } from 'react';
import { styled } from "styled-components";
import HowItWork from "./howItWork/HowItWork";
import LetsStart from "./letsStart/LetsStart";
import Wizard from "./wizard/Wizard";
import Publish from "./publish/Publish";

const Wrapper = styled.div`
  .wizardWrapper {
      display: flex;
      height: 100vh;
      flex-direction: column;
  }
  .wz_container {
      display: flex;
  }
  .typography {
      color: var(--Purple-Primary, #9738FF);
      font-variant-numeric: lining-nums proportional-nums;
      
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: 1.4px;
      text-transform: uppercase;
      margin: 0px;
      padding: 0px;
  }
  .title {
      color: var(--Black-00, #000);
      font-family: Recoleta;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
      margin: 0px;
      padding: 0px
  }
  h1 {
      color: #000;
      font-family: Recoleta;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      text-transform: capitalize;
  }
  p {
      color: var(--Black, #000);
      font-variant-numeric: lining-nums proportional-nums;
      
      font-size: 12.723px;
      font-style: normal;
      font-weight: 400;
      line-height: 170%;
  }
`;

const EasyLlamaWizard = ({ jwt, trainingId, companyId, redirect, originalTemplateId }) => {
  const [step, setStep] = useState(1);
  const [training_id, setTraining_id] = useState(trainingId);

  useEffect(() => {
    if (training_id) {
      setStep(3);
    }
  }, [training_id]);

  return <Wrapper>
    {step === 1 && <HowItWork activeStep={step} btnEvent={() => setStep(2)} />}
    {step === 2 && <LetsStart
      jwt={jwt}
      activeStep={step}
      btnBackEvent={() => setStep(1)}
      btnNextEvent={() => setStep(3)}
      setTraining_id={setTraining_id}
      companyId={companyId}
      redirect={redirect}
      originalTemplateId={originalTemplateId}
    />}
    {step === 3 && <Wizard
      jwt={jwt}
      showCourseNavigation={trainingId}
      companyId={companyId}
      trainingId={training_id}
      btnBackEvent={() => setStep(2)}
      btnNextEvent={() => setStep(4)} activeStep={step}
    />}
    {step === 4 && <Publish
      jwt={jwt}
      activeStep={step}
      btnBackEvent={() => setStep(3)}
      companyId={companyId}
      trainingId={training_id}
    />}
  </Wrapper>
};

export default EasyLlamaWizard;
